import { render, staticRenderFns } from "./NewVehicle.vue?vue&type=template&id=23817eb0&"
import script from "./NewVehicle.vue?vue&type=script&lang=js&"
export * from "./NewVehicle.vue?vue&type=script&lang=js&"
import style0 from "./NewVehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports